import React, { useState, cloneElement } from "react";
import { Header, Icon, Modal } from "semantic-ui-react";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";

type ConfirmationPromptProps = {
  headerIcon: string;
  trigger: React.ReactElement;
  buttonColor?: string; // Unused
  buttonLabel?: string; // Unused
  content: string;
  disabled?: boolean; // Unused
  onConfirmation: () => void;
};

const ConfirmationPrompt = ({
  headerIcon,
  content,
  trigger,
  onConfirmation
}: ConfirmationPromptProps) => {
  const [open, setOpen] = useState(false);

  const openConfirmation = () => {
    setOpen(true);
  };

  const closeConfirmation = () => {
    setOpen(false);
  };

  const handleConfirmation = () => {
    onConfirmation();
    closeConfirmation();
  };

  return (
    <Modal
      open={open}
      closeIcon
      onClose={closeConfirmation}
      trigger={cloneElement(trigger, { onClick: openConfirmation })}
      size="mini"
    >
      <Header icon={headerIcon} />
      <Modal.Content>{content}</Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={closeConfirmation}>
          <Icon name="remove" /> No
        </Button>
        <Button color="green" onClick={handleConfirmation}>
          <Icon name="checkmark" /> Yes
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmationPrompt;
